import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CategorySlider.css';

function CategorySlider({ onCategorySelect }) {
  const [categories, setCategories] = useState([]);
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}product_categories`;

  useEffect(() => {
    axios.post(apiUrl).then((res) => {
      if (res.data.api_success) {
        setCategories(res.data.data);
      }
    });
  }, [apiUrl]);

  return (
    <div className="category-slider">
      <div className="header">
        <h2>Shop Categories</h2>
      </div>

      <div className="categories">
        {categories.map((item) => (
          <div
            className="category"
            key={item.product_category_id}
            onClick={() => onCategorySelect(item.product_category_id)}
          >
            <div className="circle">
              <img src={item.category_logo} alt={item.product_category_name} />
            </div>
            <p>{item.product_category_name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}



export default CategorySlider;
